import React from 'react';
import { Stack } from 'new/elements/Stack';
import { useParams, withRouter } from 'react-router-dom';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';

import { ModalFilePreview } from 'new/elements/ModalFilePreview';
import { ModalMoveToProject } from 'new/elements/ModalMoveToProject';
import { ModalReingest } from 'new/elements/ModalReingest';
import { ModalAddToMarketplace } from 'new/elements/ModalAddToMarketplace/ModalAddToMarketplace';

import PipelinesContainer from './PipelinesContainer';
import { BannerDescription } from 'new/elements/BannerDescription';
import UncategorizedPipelines from 'new/components/pipelines/UncategorizedPipelines';

const WithRouterPipelinesContainer = withRouter(PipelinesContainer);

export function PipelinesByProjectGuard(props) {
  const { projectId } = useParams<{ projectId: string }>();

  if (projectId === 'uncategorized') {
    return (
      <Stack>
        <BannerDescription
          title="Uncategorized Flows"
          description="Flows that are not assigned to any project"
        />
        <UncategorizedPipelines />
      </Stack>
    );
  }

  if (typeof projectId === 'string') return <WithRouterPipelinesContainer {...props} />;

  return null;
}

PipelinesByProjectGuard.screenConfig = {
  screenName: 'PipelinesByProjectContainer',
  domain: 'integrate',
  exact: true,
  modals: [ModalFilePreview, ModalReingest, ModalMoveToProject, ModalAddToMarketplace],
  path: `${ROUTE_REDESIGN}${ROUTE_CONNECT}/projects/:projectId`,
  pageTitle: 'Project Detail',
  defaultProps: {
    withHeader: false,
    disableProjectView: true,
  },
};

export default PipelinesByProjectGuard;
